export default class Customer {

  constructor(modelData, store) {
    this.store = store

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
  }

  getDefault() {
    return {
      id: null,
      name: null,
      sendunitPoolId: null,
      applicationServerName: null,
      applicationServerId: null,
      mediaManagerId: null,
      // address: null,
      // city: null,
      // zip: null,
      // land: null,
      contractStart: null,
      contractEnd: null,
      storageUsage: 0,
    }
  }

  // assumed for this.model.storageUsage
  getNumberAsMB(value) {
    if (value) {
      const mbValue = Math.trunc(value / 1024 / 1024)
      return this.getLocalNumber(mbValue)
    }

    else if (value === 0) {
      return 0
    }
    // if here, then the property is not in the response
    return 'NA'

  }

  getLocalNumber(num = 0) {
    return num.toLocaleString(this.store.getters.locale)
  }

  set(data) {
    Object.assign(this, data)
    if (this.storageUsage && this.storageUsage.totalSize) {
      this.storageUsage = this.getNumberAsMB(this.storageUsage.totalSize)
    }
    else {
      this.storageUsage = 0
    }
  }

  getJSON() {
    return {
      id: this.id,
      name: this.name,
      sendunitPoolId: this.sendunitPoolId,
      applicationServerName: this.applicationServerName,
      applicationServerId: this.applicationServerId,
      mediaManagerId: this.mediaManagerId,
      // address: this.address,
      // city: this.city,
      // zip: this.zip,
      // land: this.land,
      contractStart: this.contractStart,
      contractEnd: this.contractEnd
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/customer/model.js